(function () {
    /**
     * Meeting service is mostly responsible for handling joining to Web conference rooms.
     */
    angular.module('tradersyard').factory('MeetingService', meetingServiceFactory);

    meetingServiceFactory.$inject = ['$rootScope', '$window', 'WebSocket', 'graph-meeting-factory', 'CallService'];

    var FRIEND_CHAT = 'friend-chat';

    const WINDOW_OPTIONS =
        'width=1260,height=720,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes';

    function meetingServiceFactory($rootScope, $window, WebSocket, meetingApi, CallService) {
        // REFACTOR: Move this to a .run block
        CallService.onIncomingCall(function (answerPromise) {
            answerPromise.then(function (someMeetingData) {
                console.log('Incoming call accepted', someMeetingData);
            });
        });

        return {
            openMeetingWindow,
            openConferenceWindow,
            openVideoConferencePopup,
            triggerMeetingIframe,
            openMeetingWindowForMeeting: openPrivateMeetingWindow,
            joinMeeting: joinGroupMeeting,
            startCall: startPrivateCall,
            getRoomNameForMeeting,
            canMakeCallToUser,
            generateUrl,
            getVideoConferenceUrl,
        };

        /**
         * Opens a new popup window
         * @param meeting
         */
        function startPrivateCall(meeting) {
            return CallService.startCall(meeting.id);
        }

        function openPrivateMeetingWindow(friendId) {
            console.log('Opening window for friend', friendId);
            var ourIds = sortNumbersAsc([friendId, $rootScope.me.id]).join('-');
            return openMeetingWindow(FRIEND_CHAT, ourIds);
        }

        /**
         * Join a group meeting using Choop.Chat video confere
         *
         * @param {object} meeting
         */
        function joinGroupMeeting(meeting) {
            openVideoConferencePopup(meeting.id);
        }

        /**
         * Open video conference popup for meeting.
         *
         * @param {number} meetingId
         */
        function openVideoConferencePopup(meetingId) {
            const url = getVideoConferenceUrl(meetingId);
            $window.open(url, `video-conference-${meetingId}`, WINDOW_OPTIONS);
        }

        /**
         * Opens a small window where user will wait for authentication to join meeting room.
         * On success, the user is redirected to a Choop Chat meeting room.
         *
         * This method is deprecated. We have changed how URL is built,
         * use {@link openVideoConferencePopup} instead.
         *
         * @param roomType
         * @param roomTypeId
         * @deprecated
         */
        function openMeetingWindow(roomType, roomTypeId) {
            // The window should have a limited UI.
            const url = generateUrl(roomType, roomTypeId);
            $window.open(url, '_blank', WINDOW_OPTIONS);
        }

        /**
         * Opens a small window where user will wait for authentication to join meeting room.
         * On success, the user is redirected to a Choop Chat meeting room.
         *
         * This method is deprecated. We have changed how URL is built,
         * use {@link openVideoConferencePopup} instead.
         *
         * @deprecated
         * @param roomType
         * @param roomTypeId
         * @param jistiParams = {
         *      muted_audio: true/false,
         *      muted_video: true/false,
         *      share_screen: true/false,
         *      toggle_view: true/false
         * }
         */
        function openConferenceWindow(roomType, roomTypeId, jistiParams) {
            // The window should have a limited UI.
            var windowOptions =
                'channelmode=yes,width=800,height=600,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes';
            var url = generateUrl(roomType, roomTypeId);

            if (typeof jistiParams !== 'undefined') {
                if (jistiParams.share_screen == true) {
                    jistiParams.muted_video = false;
                }

                var params = {
                    'config.startWithAudioMuted': jistiParams.muted_audio,
                    'config.startWithVideoMuted': jistiParams.muted_video,
                    'config.startScreenSharing': jistiParams.share_screen,
                };

                url += '?startArgs=' + encodeURIComponent(new URLSearchParams(params));
            }

            $window.open(url, `Meeting${roomType}${roomTypeId}`, windowOptions);
        }

        /**
         * Set trigger to open coopchat iframe.
         * @param roomType
         * @param roomTypeId
         */
        function triggerMeetingIframe(roomType, roomTypeId) {
            $rootScope.$broadcast('web-meeting:open', {});
        }

        function inviteUser(meetingRoomName, friendId) {
            return meetingApi.inviteFriendToMeeting(meetingRoomName, friendId);
        }

        /**
         * IMPORTANT: you need to be logged in.
         * @param meeting
         * @returns {string}
         */
        function getRoomNameForMeeting(meeting) {
            if (meeting.type === 'private') {
                var friendId = meeting.place.id;
                var ourIds = sortNumbersAsc([friendId, $rootScope.me.id]);
                return ['friend-chat'].concat(ourIds).join('-');
            }

            return [meeting.type, meeting.id].join('-');
        }

        /**
         * Check if the currently logged in user is allowed to contact someone based on meeting data returned by the server.
         * IMPORTANT: This assumes you fetched the meeting data from a specific endpoint that exposes the `can_contact` property.
         *
         * @param {ApiMeetingData} meeting
         * @returns {string}
         */
        function canMakeCallToUser(meeting) {
            var canContact = true;

            if (meeting.place.name === 'user') {
                canContact = meeting.place.location.can_contact;
            }

            return canContact;
        }

        /**
         * Building url to join meeting.
         *
         * @param roomType
         * @param roomTypeId
         * @returns {string}
         */
        function generateUrl(roomType, roomTypeId) {
            const roomName = roomType + '-' + roomTypeId;
            return $window.location.origin + '/meeting/join/' + roomName;
        }

        /**
         * Generate URl to a video conference page where <ty-video-conference-app /> is hosted.
         *
         * @param meetingId
         * @return {string}
         * @private
         */
        function getVideoConferenceUrl(meetingId) {
            return $window.location.origin + '/video-conference/' + meetingId;
        }
    }

    function sortNumbersAsc(values) {
        return values.map(Number).sort(function (a, b) {
            return a - b;
        });
    }
})();
